import {useEffect,useState} from 'react';
import {traderAPI} from '../context/TraderAuthContext';

export const useOrderPreview=(enabled,payload)=>{
  const [state,setState]=useState({data:null,error:'',loading:false});
  const signature=JSON.stringify(payload);
  useEffect(()=>{
    if(!enabled)return;
    const controller=new AbortController();let alive=true;
    setState(previous=>({...previous,loading:true,error:''}));
    const timer=setTimeout(()=>traderAPI.post('/api/trader/orders/preview',JSON.parse(signature),{signal:controller.signal}).then(({data})=>{if(alive)setState({data,error:'',loading:false});}).catch(error=>{if(alive)setState({data:null,error:typeof error.response?.data?.detail==='string'?error.response.data.detail:'Margin unavailable',loading:false});}),300);
    return()=>{alive=false;controller.abort();clearTimeout(timer);};
  },[enabled,signature]);
  return state;
};